<ch-base-banner [goBack]="this.goBack.bind(this)">
  <div class="banner-content" *ngIf="facility">
    <div>
      <span>NAME: </span>
      {{ facility?.name }}
    </div>
    <mat-divider class="banner-dividers" [vertical]="true"> </mat-divider>
    <div>
      <span>NPI: </span>
      {{ facility?.npi }}
    </div>
    <mat-divider class="banner-dividers" [vertical]="true"></mat-divider>
    <div>
      <span>STATUS: </span>
      {{ facilityStatus | async }}
    </div>
  </div>
</ch-base-banner>
